// extracted by mini-css-extract-plugin
export default {"root":"ResetPasswordComponent-root","infoMessage":"ResetPasswordComponent-infoMessage"};